import { ProjectViewModel } from "../ViewModel/ProjectViewModel";
import { parseDate } from "./ParseDate";

export function parseAllDateFields(
  project: ProjectViewModel
): ProjectViewModel {
  if (project.StartDate) {
    project.StartDate = new Date(project.StartDate as never);
  }
  if (project.EndDate) {
    project.EndDate = new Date(project.EndDate as never);
  }
  if (project.LastModified) {
    project.LastModified = new Date(project.LastModified as never);
  }

  project.FTLRoutes?.forEach((x) => {
    x.RoutingTable?.forEach((y) => {
      if (y.GeoLocation) {
        y.GeoLocation.DeletedAt = parseDate(y.GeoLocation.DeletedAt as never);
      }
      if (y.Dock) {
        y.Dock.DeletedOn = parseDate(y.Dock.DeletedOn as never);
      }
    });
  });
  return project;
}
